'use strict';
import { createAction } from 'redux-actions';

const GUIDE_ROUTE_CHANGE = 'GUIDE_ROUTE_CHANGE';

export const guideRouteChange = createAction(GUIDE_ROUTE_CHANGE);
